const routes = [
  {
    index: true,
    label: 'Ajith Joseph',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  // {
  //   label: 'Projects',
  //   path: 'https://codzz.com/#projects',
  //   isExternal: true,
  //   highlight: true,
  // },
  // {
  //   label: 'API',
  //   path: '/API',
  // },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'AI ChatBot',
    path: '/ai/chatbot',
  },
  {
    label: 'AI Collections',
    path: '/ai/all',
  },
  {
    label: 'Blog',
    path: 'https://blog.ajithjoseph.com/',
    isExternal: true,
    highlight: true,
  },
  {
    label: 'Contact Me',
    path: '/contact',
  },
];

export default routes;
